import * as R from 'ramda';
import React, { useEffect } from 'react';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// icons
import * as I from '../../../svgs';
// ui
import { Box, Flex, ReactSelect, ReactAsyncSelect, ReactSortableMultiselect } from '../../../ui';
//////////////////////////////////////////////////

export const AsyncReactSelectInput = (props) => {
  const {
    id,
    value,
    width,
    height,
    showIcon,
    placeholder,
    getLoadOptions,
    handleAsyncSearchSelectChange,
  } = props;

  return (
    <Flex>
      <ReactAsyncSelect
        id={id}
        width={width}
        value={value}
        height={height}
        placeholder={placeholder}
        getLoadOptions={getLoadOptions}
        handleAsyncSearchSelectChange={handleAsyncSearchSelectChange}
      />
      {showIcon && <Box ml={10}>{I.search()}</Box>}
    </Flex>
  );
};

const ReactSelectInput = (props) => {
  const {
    id,
    value,
    width,
    height,
    isMulti,
    options,
    sortable,
    onChange,
    hasError,
    disabled,
    isGrouped,
    components,
    placeholder,
    useMaxHeight,
    setFieldValue,
    shouldValidate,
    getOptionLabel,
    setFieldTouched,
    formatOptionLabel,
    closeMenuOnSelect,
    closeMenuOnScroll,
    shouldCustomChange,
    isClearable = true,
    withoutFixedHeight,
    valueContainerMaxHeight,
    useMenuPortalTarget = true,
    reactSelectAdditionalStyles,
  } = props;

  useEffect(() => {
    if (G.isNotNilAndNotEmpty(shouldValidate)) {
      const validate = G.ifElse(shouldValidate, shouldValidate, false);

      setFieldTouched(id, true, validate);
    }
  }, []);

  const handleBlur = () => {
    const validate = G.ifElse(G.isNotNilAndNotEmpty(shouldValidate), shouldValidate, true);

    setFieldTouched(id, true, validate);
  };

  const handleChange = (value) => {
    const isCustomLogic = R.and(G.isTrue(shouldCustomChange), G.isFunction(onChange));
    const inputValue = G.ifElse(R.isNil(value), GC.EMPTY_OPTION_NULLABLE_OBJECT, value);

    if (G.isTrue(isMulti)) {
      const newValue = R.map(
        (item) => G.getPropFromObject('value', item),
        inputValue,
      );

      if (G.isTrue(isCustomLogic)) return onChange(newValue, id);

      setFieldValue(id, newValue);
    } else {
      const newValue = G.getPropFromObject('value', inputValue);

      if (G.isTrue(isCustomLogic)) return onChange(newValue, id);

      setFieldValue(id, newValue);
    }
  };

  const selectProps = {
    id,
    value,
    width,
    height,
    isMulti,
    options,
    sortable,
    hasError,
    isGrouped,
    components,
    isClearable,
    placeholder,
    useMaxHeight,
    getOptionLabel,
    formatOptionLabel,
    closeMenuOnScroll,
    withoutFixedHeight,
    onBlur: handleBlur,
    useMenuPortalTarget,
    onChange: handleChange,
    valueContainerMaxHeight,
    isDisabled: R.or(disabled, false),
    additionalStyles: reactSelectAdditionalStyles,
    closeMenuOnSelect: G.ifElse(G.isFalse(closeMenuOnSelect), false, true),
  };

  if (R.and(sortable, isMulti)) return <ReactSortableMultiselect {...selectProps} />;

  if (R.and(G.isTrue(withoutFixedHeight), G.isNotNilAndNotEmpty(value))) {
    const additionalStyles = {
      input: () => ({
        display: 'none',
      }),
      singleValue: ({ color }) => ({
        color,
        padding: '5px 0',
      }),
    };

    return <ReactSelect {...selectProps} additionalStyles={additionalStyles} />;
  }

  return <ReactSelect {...selectProps} />;
};

export default ReactSelectInput;
